/*
- Drop Research Note in the Paper Editor
*/
import config from '@/config';
import PCKS_WrapCitation from '@/services/paper/ck/wrapCitation';
import PS_BuildReferencesInPaper from '@/services/paper/buildReferencesInPaper';
import router from '@/router';
import store from '@/store';
import {v4 as uuidv4} from 'uuid';
import Vue from 'vue';

CKEDITOR.plugins.add('paperDropResearchNote', {
	init(editor) {
		editor.on('paste', (evt)=>{
			let researchNoteFull = evt.data.dataTransfer.getData('researchNoteFull');
			if (!researchNoteFull) {
				return;
			}

			let citationResultObject;
			
			if(researchNoteFull.citation){
				citationResultObject = JSON.parse(researchNoteFull.citation);
				if(citationResultObject && citationResultObject.apa7 && citationResultObject.apa7.first){

					citationResultObject.citationData['citationUniqueID'] = uuidv4().toUpperCase();
					citationResultObject.citationData['referenceUniqueID'] = researchNoteFull.referenceUniqueID.toUpperCase();

					store.commit('paperEdit/citations/ADD_TO_PAPER', citationResultObject);

					let citationOutput = citationResultObject.apa7.first;
					// new citation mode doesn't have the parentheses enclosing the citation
					if(store.state.paperEdit.meta.UseNewCitationMode){
						citationOutput = citationOutput.slice(1, -1);
					}

					if(store.state.paperEdit.config.renderCitationsAsFootnotes){
						store.commit('paperEdit/footnotes/ADD_TO_PAPER', {
							citationUids: [citationResultObject.citationData.citationUniqueID],
							content: '<p>@@@</p>',
						});
					}
					

					evt.data.dataValue = researchNoteFull.note + '&nbsp;' +
					
						`<span class="perrla_citation"
								data-citation-unique-id="` + citationResultObject.citationData.citationUniqueID + `"
								data-reference-unique-id="` + citationResultObject.citationData.referenceUniqueID + `">`+ citationOutput + `</span>
						`;
				}
			}
			
			// after the citation is inserted update the values (this pays off when you have a group author with abbreviation and subsequent citations)
			Vue.nextTick(()=>{
				PS_BuildReferencesInPaper().then(()=>{
				
					if(researchNoteFull.citation){
						PCKS_WrapCitation({
							citationUniqueID: citationResultObject.citationData.citationUniqueID,
						});
					}
					if(router.currentRoute.meta.tab === config.enums.Tab.EDITOR){
						// editor.execCommand('autocorrect');
						store.commit('paperEdit/researchNotes/RESEARCH_NOTE_ADD_ACTIVE', researchNoteFull.researchNoteId);
					}
				});
			});
		});
	}
});
